import { z } from "zod";
import { AccrualUpdate } from "./accrual";
import { common } from "./common";
import { SnapshotUpdates } from "./snapshot";
import { usageSchema, UsageUpdate } from "./usage";

const buildEmployeeUsageSchemaOpts = z
  .object({
    companyID: z.string(),
    employees: z.array(usageSchema),
  })
  .merge(common);

export type UsageOpts = z.infer<typeof buildEmployeeUsageSchemaOpts>;

export type Updates = {
  accruals: AccrualUpdate;
  snapshots: SnapshotUpdates;
  usage: UsageUpdate;
  results: {
    companyID: string;
    policyID: string;
    employeeID: string;
    correction: boolean;
    amount: number;
    start_date: string;
    end_date: string;
  }[];
};
